import { Component, ChangeDetectionStrategy } from '@angular/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { TuiDialogContext } from '@taiga-ui/core';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'lp-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent extends BaseResizableComponent {
  private readonly context = injectContext<TuiDialogContext<void | boolean, string>>();

  get text() {
    return this.context.data;
  }

  cancel() {
    this.context.completeWith();
  }

  confirm() {
    this.context.completeWith(true);
  }
}
